<template>
  <div class="hello">
    <router-view>

    </router-view>
  </div>
</template>

<script>
export default {
    name: 'loginRouter',
    data () {
        return {

        };
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/loginRouter.vue